import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ae9038e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-full" }
const _hoisted_2 = { class: "hands-on-title flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white font-semibold" }, "已上机", -1))
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "allChooseTitle" }, "全选", -1))
const _hoisted_7 = { class: "already-people-list scrollBar w-full h-full flex-1" }
const _hoisted_8 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_JOnWorkCheck = _resolveComponent("JOnWorkCheck")!
  const _component_JOnwork = _resolveComponent("JOnwork")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, "当前总绩效：" + _toDisplayString(_ctx.totalCoefficient ? _ctx.totalCoefficient : 0) + "%", 1),
        (_ctx.offWorkBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_checkbox, {
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCheckAllChange($event))),
                checked: _ctx.checked,
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checked) = $event))
              }, null, 8, ["checked"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_checkbox_group, {
          value: _ctx.offWorkChecked,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.offWorkChecked) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plainOptions, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "already-people-item",
                key: index
              }, [
                (_ctx.offWorkBtn || _ctx.onWorkBtn)
                  ? (_openBlock(), _createBlock(_component_JOnWorkCheck, {
                      key: 0,
                      data: item
                    }, null, 8, ["data"]))
                  : (_openBlock(), _createBlock(_component_JOnwork, {
                      key: 1,
                      onCoefficient: _ctx.coefficient,
                      data: item,
                      editPerformanceBtn: _ctx.editPerformanceBtn
                    }, null, 8, ["onCoefficient", "data", "editPerformanceBtn"]))
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ]))
}